export default __webpack_public_path__ + "static/6-597e201023bc6774c5351cf40371d596.woff2";